// начало теста
$('body').on('click', '.btn-start-test', function() {
    var test_id = $(this).data('test-id');

    startTest(test_id);
})

// следующий вопрос
$('body').on('click', '.btn-test-next', function(event) {
    event.preventDefault();

    $(this).addClass('btn-preloader');

    var question_id = $('.test__question-number').data('question-id');
    answer(question_id, $('.answers-form'));
})

// начало теста
function startTest(test_id) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    dataToSend = 'test_id=' + test_id + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/test-start/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                $('.test-wrap').empty().append(responseObj.templates.question);
                var startTime = $('.test-timer_long').data('start-time'),
                    currentTime = $('.test-timer_long').data('current-time');

                upTimer(startTime, currentTime);
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        }
    });
}

// ответ на вопрос
function answer(question_id, jqForm) {
    var csrfmiddlewaretoken = getCookie('csrftoken'),
        dataToSend;

    trimFormFields(jqForm);
    dataToSend = 'question_id=' + question_id + '&' + jqForm.serialize() + '&csrfmiddlewaretoken=' + csrfmiddlewaretoken;

    // console.log(dataToSend);

    $.ajax({
        data: dataToSend,
        url: '/api/site/answer/',
        method: 'POST',

        success: function(response) {
            var responseObj = JSON.parse(response);

            // console.log(responseObj);

            if (responseObj.status == true) {
                $('.test-wrap').empty().append(responseObj.templates.question);
                var startTime = $('.test-timer_long').data('start-time'),
                    currentTime = $('.test-timer_long').data('current-time');

                upTimer(startTime, currentTime);
            }
            else {
                if (responseObj.message) showNotification(responseObj.message, 'error');
            }
        },
        complete: function() {
            setTimeout(function() {
                $('.btn-test-next').removeClass('btn-preloader');
            }, 1000);
        }
    });
}